import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { FormGroup } from '@angular/forms';
import { SelectAccountFormBuilder } from './select-account-form.builder';
import { TranslateService } from '@ngx-translate/core';
import { CompanyAccount } from '../../store/models/sub-models/company-account.model';

@Component({
  selector: 'app-select-account-form',
  templateUrl: './select-account-form.component.html',
  styleUrls: ['./select-account-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [SelectAccountFormBuilder],
})
export class SelectAccountFormComponent implements OnInit {
  @Input() accounts: List<CompanyAccount>;

  @Output() buttonSubmit = new EventEmitter<String>();

  formKeys: any;
  form: FormGroup;
  defaultCompanyName: string;

  constructor(
    private _selectAccountFormBuilder: SelectAccountFormBuilder,
    private _translateService: TranslateService
  ) {}

  get selectAccount() {
    return this.form.get(this.formKeys.SELECT_ACCOUNT);
  }

  ngOnInit() {
    this.formKeys = this._selectAccountFormBuilder.FORM_KEYS;
    this.form = this._selectAccountFormBuilder.buildForm();
    this.defaultCompanyName = this._translateService.instant(
      'SELECT_ACCOUNT.DEFAULT_COMPANY_NAME'
    );
  }

  submit() {
    const accountId = this.selectAccount.value;
    this.buttonSubmit.emit(accountId);
  }
}
